import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-509ce870"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "preview_header"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1));
const _hoisted_3 = /*#__PURE__*/_createTextVNode("此为项目预览链接，仅供团队内部查看，请勿随意外传");
const _hoisted_4 = [_hoisted_2, _hoisted_3];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock(_Fragment, null, [$options.is_preview ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4)) : _createCommentVNode("", true), _createVNode(_component_router_view, {
    class: _normalizeClass({
      active: $options.user_center_show && $options.isShowHeader,
      activeNav: $options.isShowNav,
      activePro: $options.user_center_show && $options.isShowHeader && $options.isShowNav,
      viewBox: true
    })
  }, null, 8, ["class"])], 64);
}